'use strict';

var _ = require('lodash');
var budgetTargetSearchService = function budgetTargetSearchService(searchCriteriaRsqlQueryService, momentService) {
  function filterNotTimeAndDateOrLocationSearchCategories(criteriaRules) {
    return _.filter(criteriaRules, function (rule) {
      return rule.category === 'Time & Date' || rule.category === 'Location';
    });
  }
  function cutDateFromRuleDates(operand) {
    return operand.startOf('month');
  }
  function transformSearchRule(searchCriteriaRules) {
    return _.transform(filterNotTimeAndDateOrLocationSearchCategories(searchCriteriaRules), function (result, entry) {
      var newEntry = _.cloneDeep(entry);
      if (momentService.isMoment(entry.leftOperand)) {
        newEntry.leftOperand = cutDateFromRuleDates(entry.leftOperand);
      }
      if (momentService.isMoment(entry.rightOperand)) {
        newEntry.rightOperand = cutDateFromRuleDates(entry.rightOperand);
      }
      return result.push(newEntry);
    });
  }
  function createBudgetTargetSearchRule(searchCriteriaRules) {
    if (_.isString(searchCriteriaRules)) {
      return searchCriteriaRules;
    }
    return searchCriteriaRsqlQueryService.getRsqlQueryFromSearchCriteriaRules(transformSearchRule(searchCriteriaRules));
  }
  return {
    createBudgetTargetSearchRule: createBudgetTargetSearchRule
  };
};
budgetTargetSearchService.$inject = ['SearchCriteriaRsqlQueryService', 'MomentService'];
module.exports = budgetTargetSearchService;